import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';

import { tableList } from 'View/report-help-partner/section/table/const';
import { useReportHelpPartnerState } from 'View/report-help-partner/state';

import styles from './styles.module.css';
import { TableSkeleton } from 'View/report-help-partner/component/skeleton/index';

const Table = ({ dataReport, isFetching, t }) => {
  const { updateFilterState, filterState } = useReportHelpPartnerState();

  const onChangePagination = (page) => updateFilterState({ page });
  const onSort = (sort) => updateFilterState({ sort });

  return (
    <Condition statement={!isFetching} fallback={<TableSkeleton />}>
      <Box className={styles['table__container']} data-testid="table">
        <Box className={styles['table__wrapper']}>
          <TableComponent
            tableName="table__report-attendance"
            columns={tableList({t})}
            dataSource={dataReport?.helpHostReports}
            isDataExist={dataReport?.isDataExist}
            onSort={onSort}
            sortingData={filterState.sort}
            maxTableHeight="calc(100vh - 272px)"
            maxTableBodyHeight="calc(100vh - 375px)"
            tableComponentHeight="calc(100vh - 205px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: dataReport?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Box>
    </Condition>
  );
};

export default Table;
